import request from './request';

/**
 * 拉取弹幕列表（按时间轴全量，前端本地调度飘出）
 * @param {Object} params
 * @param {Number} params.video_id 视频ID
 * @param {Number} [params.limit] 最大条数
 */
export function getDanmakuList(params) {
  return request.get('/api/danmaku/index', { params });
}

/**
 * 发送弹幕
 * @param {Object} data
 * @param {Number} data.video_id 视频ID
 * @param {String} data.content 内容
 * @param {Number} data.video_time 当前播放时间点(秒)
 * @param {String} [data.color] 颜色
 * @param {String} [data.position] scroll|top|bottom
 * @param {Number} [data.fontsize] 字号
 */
export function sendDanmaku(data) {
  return request.post('/api/danmaku/send', data);
}

/**
 * 撤回自己的弹幕
 */
export function recallDanmaku(id) {
  return request.post('/api/danmaku/recall', { id });
}

/**
 * 我发过的弹幕
 */
export function getMyDanmaku(params) {
  return request.get('/api/danmaku/my', { params });
}
